/**
 * charts register
 */
var registedChartModels = {};
export function registerChart(chartType, chartModel) {
    registedChartModels[chartType] = chartModel;
}
export function getRegisteredChart(chartType) {
    return registedChartModels[chartType];
}
